import { StackedTalosLogo } from '@talos/kyoko';
import type { HTMLAttributes } from 'react';
import styled from 'styled-components';
import { useClientLogo } from './useClientLogo';

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colorTextAttention};
  font-size: ${({ theme }) => theme.fontSizeLarge}rem;
`;

const CollapsedLogoImg = styled.img`
  max-height: 25px;
  min-width: 25px;
  object-fit: contain;
`;

const EmptyBox = styled.div``;

export const StackedLogo = ({
  showLabel,
  ...props
}: {
  showLabel?: boolean;
} & HTMLAttributes<HTMLDivElement>) => {
  const logoResult = useClientLogo({ collapsed: true });

  if (logoResult.state === 'talos') {
    return <StackedTalosLogo showLabel={showLabel} data-testid="talos-logo" />;
  }

  // if faulty config from org config we just need the component to take up space
  if (logoResult.state === 'empty') {
    return (
      <LogoWrapper {...props}>
        <EmptyBox data-testid="empty-logo" />
      </LogoWrapper>
    );
  }

  return (
    <LogoWrapper {...props}>
      <CollapsedLogoImg src={logoResult.filepath} data-testid="client-logo" />
    </LogoWrapper>
  );
};
